import {Component, Input, OnDestroy} from '@angular/core';
import {AsyncPipe, NgForOf, NgIf} from "@angular/common";
import {ButtonModule} from "primeng/button";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {DataViewModule} from "primeng/dataview";
import {MenuModule} from "primeng/menu";
import {OrderListModule} from "primeng/orderlist";
import {ProjectDescriptorComponent} from "../../project-descriptor/project-descriptor-entries/project-descriptor/project-descriptor.component";
import {ProjectDescriptorEditorComponent} from "../../project-descriptor/project-descriptor-entries/project-descriptor-editor/project-descriptor-editor.component";
import {SharedModule} from "primeng/api";
import {SkeletonModule} from "primeng/skeleton";
import {SplitButtonModule} from "primeng/splitbutton";
import {TooltipModule} from "primeng/tooltip";
import {
    DataService
} from "../../../service/data.service";
import {PlatformRole, ProjectDescriptorUse} from 'src/app/api/enums';
import {Observable, combineLatest, Subscription} from "rxjs";
import {Router} from "@angular/router";
import {DividerModule} from "primeng/divider";
import {BetaReaderProfile, PlatformUser, ProjectDescriptorCategory} from "../../../../API";
import {ProjectDescriptorPanelComponent} from "../../project-descriptor/project-descriptor-panel.component";

@Component({
  selector: 'beta-reader-reading-profile',
  standalone: true,
    imports: [
        AsyncPipe,
        ButtonModule,
        ConfirmDialogModule,
        DataViewModule,
        MenuModule,
        NgForOf,
        NgIf,
        OrderListModule,
        ProjectDescriptorComponent,
        ProjectDescriptorEditorComponent,
        SharedModule,
        SkeletonModule,
        SplitButtonModule,
        TooltipModule,
        DividerModule,
        ProjectDescriptorPanelComponent
    ],
  templateUrl: './beta-reader-reading-profile.component.html',
  styleUrl: './beta-reader-reading-profile.component.scss'
})

export class BetaReaderReadingProfileComponent implements OnDestroy {
    protected platformUser: PlatformUser;
    protected betaReader: BetaReaderProfile;
    protected namespace: string;

    constructor(private router: Router, private dataService: DataService) {
        //We need them both, so we've got to wait for both and update when either changes
        this.subscriptions.push(this.dataService.betaReader.subscribe(u => {
            this.betaReader = u;
            this.namespace = 'BRP_'+this.betaReader.id;
            console.log("Namespace: ", this.namespace, "projectDescriptorSelections: ", this.betaReader.projectDescriptorSelections);
            if (this.betaReader.projectDescriptorSelections) {
                this.dataService.fillOriginalValues(this.namespace, this.betaReader.projectDescriptorSelections.items);
            } else {
                console.log("No betareader profile");
            }
        }));
        this.subscriptions.push(this.dataService.user.subscribe(data => {
            this.platformUser = data;

            if (!this.platformUser.roles.includes(PlatformRole.BETAREADER.valueOf())) {
                console.log('NOT AUTHORIZED TO VIEW PAGE>>>>>BETA READER');
                this.dataService.redirectToHome();
            }
        }));
    }

    private subscriptions: Subscription[] = [];
    ngOnDestroy() {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe())
    }

    save() {
        //console.log(this.values);
        this.dataService.saveBetaReaderTempToProfile(this.betaReader, this.namespace);
    }

    protected readonly ProjectDescriptorUse = ProjectDescriptorUse;
}
